<div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="24px">
  <div class="title" fxLayout="column" fxLayoutAlign="center stretch">
    <h2 class="title-page-text">
      {{ 'keywords.declaration_title' | translate }}
    </h2>
    <p class="text-color-default">
      {{ 'keywords.declaration_subtitle' | translate }}
    </p>
  </div>

  <mat-card class="p-25" fxLayout="column">
    <div class="declaration-container" fxLayout="column" fxLayoutGap="20px">
      <ng-container *ngIf="hidePdf; else iframeContainer">
        <div
          class="text-title-gray"
          [ngClass]="signature ? 'mb-0' : ''"
          [innerHTML]="declarationText | translate"></div>
        <div fxLayout="column" class="w-40">
          <img class="image" [src]="signature" />
          <mat-divider></mat-divider>
        </div>
        <div>
          <span class="text-title-default">{{ 'keywords.signature' | translate }}</span>
        </div>
      </ng-container>
    </div>
  </mat-card>

  <div fxFlex="row" fxFlexAlign="end" fxLayoutGap="8px">
    <button *ngIf="!hasSignature" class="small-button-white" mat-button type="button" (click)="back()">
      {{ 'keywords.back' | translate }}
    </button>
    <button *ngIf="!hasSignature" class="medium-button-blue" mat-button type="button" (click)="saveAsDraft()">
      {{ 'keywords.save_as_draft' | translate }}
    </button>
    <button *ngIf="!hasSignature" class="medium-button-blue" mat-button type="button" (click)="hideShowPDF()">
      {{ hidePdf ? ('keywords.show_pdf' | translate) : ('keywords.hide_pdf' | translate) }}
    </button>
    <button
      *ngIf="!hasSignature && pdfFileURL && !hidePdf"
      mat-button
      class="medium-button-blue"
      mat-button
      type="button"
      (click)="openSignaturePopup()">
      {{ 'keywords.add_signature' | translate }}
    </button>
        <button *ngIf="!hidePdf" class="medium-button-blue" mat-button type="button" (click)="submit()">
        <!-- Temporary solution until DocuSign is up and running 
        <button *ngIf="hasSignature && !hidePdf" class="medium-button-blue" mat-button type="button" (click)="submit()"> -->
      {{ submitBtnLabel | translate }}
    </button>
  </div>
</div>

<ng-template #iframeContainer>
  <embed class="embeded-file" [src]="pdfFileURL" type="application/pdf" />
</ng-template>
